
/* ----------------------------------------------- */
/* !product-desc-info-acordion */
/* ----------------------------------------------- */

document.addEventListener("DOMContentLoaded", function() {

  const accordionContents = document.querySelectorAll(".product-desc-info-acordion__content");
  
  accordionContents.forEach(accordionContent => {
    accordionContent.style.maxHeight = "0";
  });

  const accordionTitles = document.querySelectorAll(".product-desc-info-acordion__title");
  
  accordionTitles.forEach(accordionTitle => {
    accordionTitle.addEventListener("click", function() {
      const accordionContent = accordionTitle.nextElementSibling;
      if (accordionContent.style.maxHeight === "0px") {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
      } else {
        accordionContent.style.maxHeight = "0";
      }
    });
  });

});


/* ----------------------------------------------- */
/* !product-desc-info-tab */
/* ----------------------------------------------- */

document.addEventListener('DOMContentLoaded', function() {

  var tabButtons = document.getElementsByClassName("product-desc-info-tab__button");
  var tabs = document.getElementsByClassName("product-desc-info-tab__tab");

  if (tabButtons.length > 0) {
    tabButtons[0].classList.add("active");
  }

  if (tabs.length > 0) {
    tabs[0].classList.add("active");
  }

  for (var i = 0; i < tabButtons.length; i++) {
    tabButtons[i].addEventListener('click', function(event) {
      openTab(this, this.getAttribute("data-tab"));
    });
  }
  
  function openTab(button, tabName) {
    for (var i = 0; i < tabButtons.length; i++) {
      tabButtons[i].classList.remove("active");
    }
  
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove("active");
    }
  
    button.classList.add("active");
    document.getElementById(tabName).classList.add("active");
  }

  window.addEventListener('load', function() {
    // anchor link
    var hash = window.location.hash.substring(1);
  
    if (hash) {
      for (var i = 0; i < tabs.length; i++) {
        var tabContent = tabs[i].querySelector('#' + hash);
        if (tabContent) {
          openTab(tabButtons[i], tabButtons[i].getAttribute("data-tab"));
          scrollToElement(tabContent);
          break;
        }
      }
    }
    
    function scrollToElement(element) {
      var offsetTop;
      if (window.innerWidth < 768) {
        offsetTop = element.offsetTop - 102;
      } else {
        offsetTop = element.offsetTop - 150;
      }
      window.scrollTo(0, offsetTop);
    }
  });

});

